import { useCallback, useEffect } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useRegistrationContext } from "../../context/registrationContext";

export default function GoogleRecaptcha(props: { captchaAction: string }) {
  // Captcha settings
  const CaptchaComponent = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { state, dispatch } = useRegistrationContext();

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
        return;
      }

      const token = await executeRecaptcha(props.captchaAction);
      // Do whatever you want with the token
      dispatch({ type: "setCaptcha", payload: token });
    }, [executeRecaptcha, props.captchaAction]);

    // You can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
      handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);

    return <></>;
  };

  return CaptchaComponent();
}
